import { Box } from "@mui/material";
import { InputHTMLAttributes, useEffect, useMemo } from "react";
import { DollarNarrowFormatter } from "../../../store/utils/formatUtils";
import "../Textfield1/Textfield1.css";
import { AfterFirstDigitRegex } from "../../../constants/regex";

interface PriceFIeldProps
  extends Omit<
    InputHTMLAttributes<HTMLInputElement>,
    "onChange" | "min" | "max" | "value"
  > {
  value?: number;
  min?: number;
  max?: number;
  onChange?: (value: number) => void;
  currency?: string;
}

export const PriceField = ({
  currency,
  value,
  min = 0,
  max,
  onChange,
  style = { width: 80 },
  disabled,
  className,
  placeholder,
  ...props
}: PriceFIeldProps) => {
  // Whenever the value is changed to be > max, set as max
  useEffect(() => {
    if (value && max && value > max) {
      onChange?.(max);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [max, value]);

  // On first mount, if the value is < min, we set it the min
  useEffect(() => {
    if (!value || Number.isNaN(value) || value < min) {
      onChange?.(min);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const emptyMoney = useMemo(() => {
    return DollarNarrowFormatter(currency)
      .format(0)
      .replace(AfterFirstDigitRegex, "");
  }, [currency]);

  const getValue = () => {
    if (!value) {
      return emptyMoney;
    }

    return DollarNarrowFormatter(currency).format(Math.round(value));
  };

  return (
    <Box
      sx={(theme) => ({
        ".textfield": {
          color: theme.palette.text.primary,
        },
      })}
    >
      <input
        style={style}
        disabled={disabled}
        className={className ?? "textfield"}
        name="text"
        type="text"
        value={getValue()}
        {...props}
        placeholder={placeholder}
        onBlur={() => {
          if (!value || Number.isNaN(value) || value < min) {
            onChange?.(min);
          }
        }}
        onChange={(e) => {
          const newValue = e.target.value;
          if (!newValue || newValue === emptyMoney) {
            onChange?.(0);
            return;
          }

          const cleanedString = newValue.replace(emptyMoney, "");
          const numberValue = parseInt(cleanedString);
          if (!Number.isNaN(numberValue)) {
            onChange?.(numberValue);
          }
        }}
      />
    </Box>
  );
};
